import React from 'react';
import PropTypes from 'prop-types';
import { PAGE } from 'config/types/prop';
import { setRichTextInnerHTML } from 'utils/setInnerHTML';
import withStyles from 'isomorphic-style-loader/withStyles';

import styles from '../../contentItem.css';

const DefaultPage = ({
  page: {
    title,
    content,
  },
}) => (
  <article className={styles.wrapper}>
    <header>
      <h1>{title}</h1>
    </header>
    <div>
      <div
        className={styles.content}
        dangerouslySetInnerHTML={setRichTextInnerHTML(content)} // eslint-disable-line react/no-danger
      />
    </div>
  </article>
);

DefaultPage.propTypes = {
  page: PropTypes.shape(PAGE).isRequired,
};

const wrapWithStyles = withStyles(styles);

export default wrapWithStyles(DefaultPage);
